import FullTable from 'js/components/full-table/index.js'
import API from 'js/services/api'
import template from './_table.pug'

export default Vue.extend({
  template: template(),
  components: {
    FullTable
  },
  props: {
    logs: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showFilters: true,
      filters: {
        from: '',
        to: '',
        email: '',
        ip: '',
        success: ''
      },
      successOptions: [
        { label: 'Valid', value: 'Valid' },
        { label: 'Invalid', value: 'Invalid' }
      ],
      lastQueryOptions: null
    }
  },
  computed: {
    defaultOrder() {
      return { currentField: 'datelogin', currentDir: 'asc' }
    },
    filterButtonParams() {
      return this.showFilters ? { class: 'active', icon: 'angle-up' } : { class: '', icon: 'angle-down' }
    }
  },
  methods: {
    getData(queryOptions) {
      if (!queryOptions) {
        this.resetFilters()
      }

      const finalQuery = queryOptions || { filter: { ...this.filters } }
     // this.$emit('load-data', finalQuery)

      this.$emit('load-data', finalQuery || this.lastQueryOptions)
      if (queryOptions) this.lastQueryOptions = queryOptions
    },
    exportLogs() {
      console.log(this.lastQueryOptions);
      API.loginAudit.export({ ...this.lastQueryOptions })
        .then(({ data }) => {
          window.open(data.file, '_blank')
        })
        .catch(error => {
          console.error("❌ Error exportando logs:", error)
        })
    },
    clearFilters() {
      this.resetFilters()
      this.getData()
    },
    resetFilters() {
      this.filters = {
        from: '',
        to: '',
        email: '',
        ip: '',
        success: ''
      }
    }
  }
})
